export default (fill) => (
  `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 16 16;" xml:space="preserve" width="16px" height="16px">
    <g>
      <g>
        <path d="M256,0C114.497,0,0,114.507,0,256c0,141.503,114.508,256,256,256c141.503,0,256-114.507,256-256 C512,114.497,397.492,0,256,0z M256,472c-119.393,0-216-96.615-216-216c0-119.393,96.616-216,216-216 c119.393,0,216,96.615,216,216C472,375.393,375.384,472,256,472z" fill="${fill ? fill : '#999999'}" />
      </g>
    </g>
    <g>
      <g>
        <path d="M366.29,298.85L276,244.676V96c0-11.046-8.954-20-20-20s-20,8.954-20,20v160c0,7.025,3.686,13.535,9.71,17.15l100,60 c9.471,5.683,21.758,2.611,27.439-6.86C378.833,316.818,375.762,304.533,366.29,298.85z" fill="${fill ? fill : '#999999'}" />
      </g>
    </g>
  </svg>`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/other/clock.jsx